<template>
  <div class="text-center">
    <button @click="onClick()" class="btn btn-primary mt-5 px-5" :disabled="disabled">
      <slot></slot>
    </button>
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "SubmitButton",
})
export default class SubmitButton extends Vue {
  @Prop() onClick;
  @Prop() disabled = false;
}
</script>